import { ReplicaType } from "types";
import Version1 from "./v1";
import replicaCategories from "assets/replicas/_categories";

const data: ReplicaType = {
  id: "sw-lightsaber-yoda-ep1",
  name: `Lightsaber\nMaster Yoda Ep1`,
  nameFormatted: {
    primary: "Lightsaber",
    secondary: "Master Yoda Ep1",
  },
  origin: "Star Wars: Episode I - The Phantom Menace",

  category: replicaCategories.starWars,

  versions: [Version1],
};

export default data;
